import $api from "@/zapi-frontend/shared/api/axios";

export async function updateFeaturePermission(featurePermissionLevel: number) {
  const response = await $api.post("/auth/update-feature-permission", {
    featurePermissionLevel
  });
  return response.data;
}
